import { render, staticRenderFns } from "./FamilySplit.vue?vue&type=template&id=171ad88a"
import script from "./FamilySplit.vue?vue&type=script&lang=js"
export * from "./FamilySplit.vue?vue&type=script&lang=js"
import style0 from "./FamilySplit.vue?vue&type=style&index=0&id=171ad88a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports